<template>
  <v-dialog v-model="isOpen" max-width="560" persistent>
    <v-card>
      <v-card-title>
        {{ $t("employee.tags.bulkTitle") }}
      </v-card-title>

      <v-card-text>
        <div class="mb-4 body-2">
          {{ $t("employee.tags.bulkSubtitle", { count: employeeIds.length }) }}
        </div>
        <v-combobox
          v-model="selectedTags"
          :items="tagItems"
          :label="$t('employee.tags.label')"
          multiple
          chips
          small-chips
          deletable-chips
          hide-details
          dense
          outlined
        ></v-combobox>
      </v-card-text>

      <v-card-actions>
        <v-spacer />
        <v-btn text @click="close" :disabled="loading">
          {{ $t("general.cancel") }}
        </v-btn>
        <v-btn
          color="primary"
          :loading="loading"
          :disabled="!selectedTags.length"
          @click="apply"
        >
          {{ $t("general.save") }}
        </v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script>
import { mapGetters } from "vuex";

export default {
  name: "EmployeeBulkTagDialog",
  data() {
    return {
      isOpen: false,
      loading: false,
      employeeIds: [],
      selectedTags: [],
    };
  },
  computed: {
    ...mapGetters(["allEmployeeTags"]),
    tagItems() {
      return (this.allEmployeeTags || []).map((t) => t.tag);
    },
  },
  methods: {
    open(employees) {
      this.employeeIds = (employees || []).map((e) => e._id);
      this.selectedTags = [];
      this.isOpen = true;
      this.$store.dispatch("getAllEmployeeTags");
    },
    close() {
      this.isOpen = false;
    },
    async apply() {
      if (!this.selectedTags.length) return;
      this.loading = true;
      try {
        await this.$store.dispatch("bulkAddEmployeeTags", {
          employeeIds: this.employeeIds,
          tags: this.selectedTags,
        });
        this.isOpen = false;
        this.$emit("applied");
      } catch (e) {
        // error snackbar handled in store action
      } finally {
        this.loading = false;
      }
    },
  },
};
</script>
